class TextareaProfile extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onChange(this.props.field, e.target.value);
    }

    render() {
        var self = this;

        return (
            <div
                className={'textarea-profile '+this.props.className}>

                { this.props.notes &&
                    <div className='textarea-profile__title'>
                        {this.props.title}
                    </div>
                }

                <textarea
                    disabled={this.props.disabled}
                    value={this.props.value}
                    onChange={this.onChange} />

            </div>
        );
    }
}

export default TextareaProfile;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/TextareaProfile.react.jsx